const PropertyMap = ({ latitude, longitude }) => {
  if (!latitude || !longitude) return null;

  const mapSrc = `https://maps.google.com/maps?q=${latitude},${longitude}&z=15&output=embed`;

  return (
    <iframe
      title="property-location"
      className="mw-100 rounded map-area"
      src={mapSrc}
      width="600"
      height="350"
      style={{ border: "0" }}
      allowFullScreen=""
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
    ></iframe>
  );
};

export default PropertyMap;
